import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Alert,
  CircularProgress,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
import { formatDate } from '../../utils/dateFormat';

const TodayClasses = ({ routine, onBack }) => {
  return (
    <Box sx={{ pb: 2 }}>
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Today's Classes
        </Typography>
        {routine.date && (
          <Typography variant="caption" color="text.secondary">
            {formatDate(routine.date)}
          </Typography>
        )}
      </Box>

      <Box sx={{ px: 2 }}>
        {routine.status === 'loading' && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={28} />
          </Box>
        )}

        {routine.status === 'holiday' && (
          <Alert severity="info" sx={{ borderRadius: 2 }}>
            {routine.message || 'Today is a holiday.'}
          </Alert>
        )}

        {routine.status === 'error' && (
          <Alert severity="error" sx={{ borderRadius: 2 }}>
            {routine.message || "Failed to load today's classes."}
          </Alert>
        )}

        {(routine.entries.length === 0 || routine.status === 'empty') && (
          <Alert severity="info" sx={{ borderRadius: 2 }}>
            {routine.message || 'No classes scheduled for today.'}
          </Alert>
        )}

        {routine.status === 'schedule' && routine.entries.length > 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {routine.entries.map((entry, idx) => (
              <Card
                key={`${entry.period_id}-${idx}`}
                sx={{
                  borderRadius: 3,
                  boxShadow: 2,
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    <Typography variant="subtitle2" fontWeight={700} color="primary.main">
                      {`${entry.start_time?.slice(0, 5) || '--'} - ${entry.end_time?.slice(0, 5) || '--'}`}
                    </Typography>
                  </Box>
                  <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5 }}>
                    {entry.subject_name || 'Unassigned'}
                  </Typography>
                  {entry.teacher_name && (
                    <Typography variant="body2" color="text.secondary">
                      Teacher: {entry.teacher_name}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TodayClasses;

